var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTophapLogoBlack = function SvgTophapLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3167.899,
    height: 866.95,
    viewBox: "0 0 3167.899 866.95"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 809.862,
    y1: 428.398,
    x2: 18.122,
    y2: 428.398,
    id: "tophap-logo-black_svg__c",
    gradientTransform: "scale(.95073 1.05182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#465FF5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4EF6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.976,
    y1: 0.5,
    x2: 0.016,
    y2: 0.5,
    id: "tophap-logo-black_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#465FF5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4EF6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tophap-logo-black_svg__a",
    id: "tophap-logo-black_svg__f",
    x1: 832.772,
    y1: 426.507,
    x2: 13.388,
    y2: 426.507,
    gradientTransform: "scale(.94653 1.05649)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tophap-logo-black_svg__a",
    id: "tophap-logo-black_svg__e",
    x1: 809.862,
    y1: 428.398,
    x2: 18.122,
    y2: 428.398,
    gradientTransform: "scale(.95073 1.05182)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.34 31.969 280.283 161.167c34.602 19.898 55.934 56.77 55.934 96.686v321.554c0 39.916-21.332 76.788-55.934 96.686L452.339 869.229a111.53 111.53 0 0 1-111.191 0L60.865 708.062C26.262 688.164 4.93 651.292 4.93 611.376V289.822c0-39.916 21.332-76.788 55.935-96.686L341.148 31.97a111.53 111.53 0 0 1 111.191 0z",
    id: "tophap-logo-black_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.746 340.048v339.317h-90.005V409.467zm129.008-76.621v75.148H441.746v.142H351.74v-.142H222.734v-75.148z",
    id: "tophap-logo-black_svg__g"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.93 -17.124)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tophap-logo-black_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tophap-logo-black_svg__b",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#tophap-logo-black_svg__c)",
    xlinkHref: "#tophap-logo-black_svg__b",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#tophap-logo-black_svg__d)",
    fill: "url(#tophap-logo-black_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tophap-logo-black_svg__f)",
    d: "M0 0h807.408v901.198H0z",
    transform: "translate(0 13.865)"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#tophap-logo-black_svg__g",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1485.2 617.702c25.514 0 44.649-9.046 56.874-27.67 12.225-18.624 18.604-44.697 18.604-78.752 0-34.055-6.379-60.129-18.604-77.688-12.225-17.56-31.36-26.606-56.874-26.606-25.514 0-44.65 9.046-56.875 26.606-12.225 17.56-18.603 43.633-18.603 77.688s6.378 60.66 18.603 78.752c12.226 18.092 30.83 27.67 56.875 27.67m0 71.304c-53.685 0-95.145-15.433-124.38-45.763-29.234-30.33-44.117-74.495-44.117-131.431a218.38 218.38 0 0 1 11.694-73.963c14.105-41.553 46.106-74.566 87.172-89.927a205.708 205.708 0 0 1 139.794 0 146.21 146.21 0 0 1 53.153 34.587 141.995 141.995 0 0 1 33.487 55.34 227.222 227.222 0 0 1 11.694 73.963 216.995 216.995 0 0 1-11.694 74.495 156.31 156.31 0 0 1-34.018 55.872 145.097 145.097 0 0 1-53.154 35.12 207.782 207.782 0 0 1-69.631 11.707m865.34-201.671h-180.722v191.56h-95.145v-456.02h95.145v176.129h180.722V222.876h95.146v456.018h-95.146zm350.814 42.569-39.333 2.128a223.018 223.018 0 0 0-45.18 5.853 90.31 90.31 0 0 0-26.578 11.175 30.484 30.484 0 0 0-12.225 15.43 58.59 58.59 0 0 0-3.19 19.689 31.196 31.196 0 0 0 11.695 26.073 47.802 47.802 0 0 0 31.892 9.578 94.114 94.114 0 0 0 56.343-15.963 63.409 63.409 0 0 0 19.666-22.88 67.266 67.266 0 0 0 7.442-34.056v-17.027zm2.127 106.954a175.766 175.766 0 0 1-44.118 36.183c-16.478 9.578-37.739 13.835-63.253 13.835a157.525 157.525 0 0 1-42.523-5.853 91.761 91.761 0 0 1-35.081-18.092 86.137 86.137 0 0 1-23.92-30.862 107.214 107.214 0 0 1-9.035-45.23 97.988 97.988 0 0 1 15.414-56.403 105.75 105.75 0 0 1 40.397-34.055 195.928 195.928 0 0 1 55.811-17.028 610.63 610.63 0 0 1 62.722-6.385l42.522-2.129v-16.495c0-20.22-5.846-34.587-17.009-42.037a70.427 70.427 0 0 0-39.865-11.706c-35.081 0-55.28 13.303-60.595 40.44l-81.857-7.45c5.847-35.119 21.262-60.128 45.713-75.559 24.45-15.431 57.937-23.413 99.397-23.413a207.091 207.091 0 0 1 64.847 9.046 102.463 102.463 0 0 1 43.055 26.606 104.964 104.964 0 0 1 23.387 42.036 196.124 196.124 0 0 1 7.442 55.34v210.715h-83.983zM1011.07 305.353h369.949v-82.477h-369.95zm232.812 0-95.676 95.248v278.293h95.676zm540.678 209.386c-.507 17.504 1.28 35 5.316 52.04a70.206 70.206 0 0 0 17.541 31.607 63.769 63.769 0 0 0 25.833 15.006 101.58 101.58 0 0 0 26.576 3.512 70.469 70.469 0 0 0 28.278-5.587 59.648 59.648 0 0 0 23.281-18.199 93.108 93.108 0 0 0 15.628-32.246 173.646 173.646 0 0 0 5.74-47.89 189.574 189.574 0 0 0-5.315-49.166 92.793 92.793 0 0 0-14.99-32.246 55.183 55.183 0 0 0-22.643-17.88 71.902 71.902 0 0 0-27.746-5.32 83.157 83.157 0 0 0-28.703 4.47 80.51 80.51 0 0 0-23.6 14.047 72.536 72.536 0 0 0-19.136 30.118 154.468 154.468 0 0 0-6.06 47.251zM1695.9 345.26h86.747v44.06c23.168-34.961 62.715-55.48 104.607-54.276 46.35 0 81.006 15.75 103.968 47.251 22.962 31.501 34.444 74.709 34.444 129.622a247.842 247.842 0 0 1-9.993 72.42 163.688 163.688 0 0 1-28.703 55.872 129.505 129.505 0 0 1-45.606 36.077 139.135 139.135 0 0 1-60.595 12.77 143.696 143.696 0 0 1-49.433-8.939 108.768 108.768 0 0 1-46.244-35.757v158.515h-89.298zm1230.879 169.479a200.55 200.55 0 0 0 5.315 52.04 70.206 70.206 0 0 0 17.54 31.607 63.768 63.768 0 0 0 25.834 15.006 101.527 101.527 0 0 0 26.576 3.512 70.415 70.415 0 0 0 28.065-5.587 59.594 59.594 0 0 0 23.282-18.199 93 93 0 0 0 15.627-32.246 173.858 173.858 0 0 0 5.74-47.89 189.52 189.52 0 0 0-5.315-49.166 92.793 92.793 0 0 0-14.99-32.246 55.183 55.183 0 0 0-22.643-17.88 71.85 71.85 0 0 0-27.746-5.32 83.157 83.157 0 0 0-28.703 4.47 80.51 80.51 0 0 0-23.6 14.047 72.485 72.485 0 0 0-18.923 30.118 154.47 154.47 0 0 0-6.06 47.251zm-88.66-169.478h86.746v44.06c23.168-34.961 62.715-55.48 104.607-54.276 46.35 0 81.006 15.75 103.968 47.251 22.962 31.501 34.444 74.709 34.444 129.622a247.84 247.84 0 0 1-9.887 72.154 163.688 163.688 0 0 1-28.703 55.872 129.505 129.505 0 0 1-45.606 36.077 139.135 139.135 0 0 1-60.595 12.77 143.749 143.749 0 0 1-49.433-8.939 108.767 108.767 0 0 1-46.243-35.758v158.782h-89.298z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
export default SvgTophapLogoBlack;